import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const MentionsLegales = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F6] py-24">
      <div className="max-w-4xl mx-auto px-6">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="mb-8 border-[#4A6B96] text-[#4A6B96] hover:bg-[#4A6B96] hover:text-white"
        >
          <ArrowLeft size={18} className="mr-2" />
          Retour à l'accueil
        </Button>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-12">
          <h1 className="text-4xl font-bold text-[#4A6B96] mb-8">Mentions Légales</h1>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Informations légales</h2>
              <p className="mb-4">
                <strong>Raison sociale :</strong> Esprit Ouest<br />
                <strong>Siège social :</strong> 98 Boulevard de la Reine, 78000 Versailles, France<br />
                <strong>Téléphone :</strong> 01 71 42 72 15<br />
                <strong>Email :</strong> contact@esprit-ouest.fr
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Directeur de la publication</h2>
              <p>
                Ludovic François
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Hébergement</h2>
              <p>
                Ce site est hébergé par :<br />
                <strong>Emergent AI Inc.</strong><br />
                San Francisco, CA, États-Unis<br />
                Site web : <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-white font-bold hover:underline">emergent.sh</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Propriété intellectuelle</h2>
              <p>
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
                Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Crédits</h2>
              <p>
                Photos : LF groupe<br />
                Conception et développement : LF groupe
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
